import { FormControl } from "@angular/forms";

export class PnNumberControlConfiguration {


    constructor(public Label : string, public InputId : string, public Id : string, public Control?: FormControl,public ControlName?: string,public Max?: string, public Min?: string,public scssClass?: string) {}
    public static create = (label : string, inputId : string, id : string) => new PnNumberControlConfiguration(label,inputId,id);

    setControl(value : FormControl) : PnNumberControlConfiguration
    {
        this.Control = value;
        return this;
    }

    setControlName(value : string) : PnNumberControlConfiguration
    {

        this.ControlName = value;
        return this;

    }
}
